import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=af25852c&scoped=true&"
import script from "./uploadFile.vue?vue&type=script&lang=js&"
export * from "./uploadFile.vue?vue&type=script&lang=js&"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=af25852c&prod&lang=css&"
import style1 from "./uploadFile.vue?vue&type=style&index=1&id=af25852c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af25852c",
  null
  
)

export default component.exports